
import { ref } from "@vue/reactivity";
import { computed, onMounted, onUnmounted } from "@vue/runtime-core";
export default {
  setup() {
    const screenWidth = ref(window.innerWidth);
    const screenHeight = ref(window.innerHeight);
    const topSection = ref();
    let topSectionHeight = ref(topSection?.value?.offsetHeight);
    const scrollOffset = computed(() => {
      return topSectionHeight.value || topSection?.value?.offsetHeight;
    });
    const onResize = () => {
      screenWidth.value = window.innerWidth;
      screenHeight.value = window.innerHeight;
      setTimeout(() => {
        topSectionHeight.value = topSection?.value?.offsetHeight;
      }, 400);
    };
    const mobileView = computed(() => screenWidth.value < 769);
    onMounted(() => {
      window.addEventListener("resize", onResize);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", onResize);
    });
    return {
      screenWidth,
      screenHeight,
      mobileView,
      topSection,
      scrollOffset,
    };
  },
};
